import { render, staticRenderFns } from "./PendingAmountList.vue?vue&type=template&id=c5675cbc&scoped=true&"
import script from "./PendingAmountList.vue?vue&type=script&lang=js&"
export * from "./PendingAmountList.vue?vue&type=script&lang=js&"
import style0 from "./PendingAmountList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PendingAmountList.vue?vue&type=style&index=1&id=c5675cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5675cbc",
  null
  
)

export default component.exports